import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantsContext} from '@hconnect/upm'
import {checkPermissionsByDataScope, usePermissionsParsedQuery} from '@hproduce/permissions'
import {useCallback} from 'react'

export const useCheckPlantPermission = () => {
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})
  const {data: permissions} = usePermissionsParsedQuery()

  return useCallback(
    (permissionTypes: PermissionType[], plantId: string) => {
      if (!upmPlants) return false
      const upmPlant = upmPlants[plantId]
      if (!upmPlant || !permissions) return false
      const plantContext = {plantId, countryId: upmPlant.country}
      return checkPermissionsByDataScope(permissions, plantContext, permissionTypes)
    },
    [permissions, upmPlants]
  )
}
